<template>
    <div>
        <div class="flex justify-end">
            <Form inline ref="inlineForm" :model="inlineForm" :rules="inlineRules" @submit.native.prevent="search()">
                <FormItem prop="platform">
                    <Select v-model="inlineForm.platform">
                        <Option v-for="(item, index) in configThreePlat.platform" :key="index" :value="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <FormItem prop="type">
                    <Select @on-change="changeType" :disabled="!inlineForm.platform" v-model="inlineForm.type">
                        <Option v-for="(item, index) in cpQueryData" :key="index" :value="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                <FormItem v-if="inlineForm.type.indexOf('报表') > 0" prop="time">
                    <DatePicker
                        type="datetimerange"
                        format="yyyy-MM-dd HH:mm"
                        v-model="inlineForm.time"
                        placeholder="请选择时间"
                        style="width: 300px"
                    ></DatePicker>
                </FormItem>
                <FormItem prop="queryKey">
                    <Input v-model="inlineForm.queryKey" :placeholder="cpQueryPlaceHolder" />
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="search()">查询</Button>
                </FormItem>
            </Form>
        </div>
        <div class="mt-2">
            <Card v-if="['收银台核销报表', '推广码会员充值报表'].includes(inlineForm.type)">
                <div class="flex justify-end mb-2">
                    <Button @click="downloadTable">导出报表</Button>
                </div>
                <Table :columns="tableData.title" :data="tableData.list"></Table>
                <div class="flex justify-end mt-2">
                    <Page @on-change="search" :page-size="tableData.size" :total="tableData.total"></Page>
                </div>
            </Card>
        </div>
        <div class="mt-2">
            <Card v-if="['会员信息', '冻结解冻', '余额清零', '查询用户日志'].includes(inlineForm.type) && queryData.nickname">
                <div class="flex item-center">
                    <div class="mr-10">
                        <img :src="queryData.headimgurl" class="w-20" />
                    </div>
                    <div>
                        <div class="flex">
                            <div class="flex w-48">
                                <div>会员名称:</div>
                                <div>{{ queryData.nickname }}</div>
                            </div>
                            <div class="flex">
                                <div>会员余额:</div>
                                <div>{{ queryData.membasic }}</div>
                            </div>
                        </div>
                        <div class="flex">
                            <div class="flex w-48">
                                <div>会员电话:</div>
                                <div>{{ queryData.Phone }}</div>
                            </div>
                            <div class="flex">
                                <div>赠送余额:</div>
                                <div>{{ queryData.memgiv }}</div>
                            </div>
                        </div>

                        <div class="flex">
                            <div class="flex w-72">
                                <div>会员串码:</div>
                                <div>{{ queryData.userid }}</div>
                            </div>
                            <div class="flex">
                                <div>注册日期:</div>
                                <div>{{ queryData.createTime }}</div>
                            </div>
                        </div>

                        <div class="flex">
                            <div class="flex w-72">
                                <div>会员状态:</div>
                                <Tag v-show="queryData.status === '正常'" color="success">{{ queryData.status }}</Tag>
                                <Tag v-show="queryData.status === '冻结'" color="error">{{ queryData.status }}</Tag>
                                <Tag v-show="!['正常', '冻结'].includes(queryData.status)" color="warning">{{ queryData.status }}</Tag>
                            </div>
                        </div>
                    </div>
                    <div class="flex ml-10">
                        <Button class="mr-3" type="error" v-if="queryData.status === '正常'" @click="showfrozen = true">冻结账号</Button>
                        <Button class="mr-3" type="success" v-if="queryData.status === '冻结'" @click="showfrozen = true">解冻账号</Button>
                        <Button class="mr-3" type="warning" @click="showbalance = true">余额清零</Button>
                        <Button class="mr-3" type="info" @click="getShowlogs(queryData, 'user')">操作日志</Button>
                    </div>
                </div>
                <div class="flex justify-end mb-2">
                    <Button @click="downloadTable">导出订单</Button>
                </div>
                <Table :columns="tableData.title" :data="tableData.list"></Table>
                <div class="flex justify-end mt-2">
                    <Page @on-change="search" :page-size="tableData.size" :total="tableData.total"></Page>
                </div>
            </Card>
            <Card v-if="inlineForm.type == '订单详情' && queryData.orderid">
                <div class="flex item-center">
                    <div class="flex-1">
                        <div class="flex">
                            <div>订单号:</div>
                            <div>{{ queryData.orderid }}</div>
                        </div>
                        <div class="flex">
                            <div>订单状态:</div>
                            <div>{{ queryData.state }}</div>
                        </div>
                        <div>
                            <div v-for="(item, index) in queryData.orderName" :key="index">{{ item }}</div>
                        </div>

                        <div class="flex">
                            <div class="flex w-48">
                                <div>支付金额:</div>
                                <div>{{ queryData.cash_fee }}</div>
                            </div>
                            <div class="flex">
                                <div>支付类型:</div>
                                <div>{{ queryData.paytype }}</div>
                            </div>
                        </div>
                        <div class="flex">
                            <div class="flex w-48">
                                <div>交易时间:</div>
                                <div>{{ queryData.createTime }}</div>
                            </div>
                            <div class="flex">
                                <div>退款时间:</div>
                                <div>{{ queryData.memgiv }}</div>
                            </div>
                        </div>

                        <div class="flex">
                            <div class="flex w-72">
                                <div>会员手机号:</div>
                                <div>{{ queryData.Phone }}</div>
                            </div>
                            <div class="flex">
                                <div>注册日期:</div>
                                <div>{{ queryData.createTime }}</div>
                            </div>
                        </div>
                        <div class="flex">
                            <div>商品明细:</div>
                            <div>({{ queryData.storeName }})</div>
                        </div>
                    </div>
                    <div class="mr-48">
                        <img :src="queryData.imgurl" class="w-20" />
                    </div>
                </div>
                <div v-if="queryData.state != '已退款'" class="flex justify-end mb-2">
                    <Button @click="showModal" type="error">订单退款</Button>
                </div>
                <Table :columns="queryData.goodListTitle" :data="queryData.goodList"></Table>
            </Card>
            <Card v-if="inlineForm.type == '票券详情' && Object.keys(queryData).length > 0">
                <div class="flex item-center">
                    <div class="flex-1">
                        <div class="flex">
                            <div class="flex w-96">
                                <div>券码:</div>
                                <div>{{ queryData.couponCode }}</div>
                            </div>
                            <Tag v-if="queryData.status == '已核销'" color="error">已使用</Tag>
                            <Tag v-if="queryData.status == '未使用'" color="success">未使用</Tag>
                            <Tag v-if="queryData.status == '已过期'">已过期</Tag>
                        </div>
                        <div>
                            <div class="flex">
                                <div class="flex w-72">
                                    <div>批次号:</div>
                                    <div>{{ queryData.apply }}</div>
                                </div>
                                <div class="flex">
                                    <div>有效期:</div>
                                    <div>{{ queryData.satrt }}至{{ queryData.end }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="flex">
                            <div>票券名称:</div>
                            <div>{{ queryData.asname }}</div>
                        </div>
                        <div class="flex">
                            <div class="flex w-72">
                                <div>持有用户:</div>
                                <div>{{ queryData.Phone }}</div>
                            </div>
                            <div class="flex">
                                <div>绑定时间:</div>
                                <div>{{ queryData.toGetTime }}</div>
                            </div>
                        </div>
                        <div class="flex">
                            <div class="flex">
                                <div>使用订单:</div>
                                <div>{{ queryData.orderid }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
        <Modal v-model="show" :closable="false" :mask-closable="false">
            <div>
                <h3>退款原因</h3>
                <Input v-model="note" class="w-96" />
            </div>
            <div slot="footer">
                <Button @click="show = false">取消</Button>
                <Button @click="orderRefund" type="primary">确认</Button>
            </div>
        </Modal>
        <!-- 冻结解冻余额清零弹框 -->
        <Modal v-model="showfrozen" :closable="false" :mask-closable="false">
            <div>
                <h3>操作原因</h3>
                <Input v-model="note" class="w-96" />
            </div>
            <div slot="footer">
                <Button @click="showfrozen = false">取消</Button>
                <Button @click="disableAccount(queryData)" type="primary">确认</Button>
            </div>
        </Modal>
        <!-- 余额清零弹框 -->
        <Modal v-model="showbalance" :closable="false" :mask-closable="false">
            <div>
                <h3>余额清零原因</h3>
                <Input v-model="note" class="w-96" />
            </div>
            <div slot="footer">
                <Button @click="showbalance = false">取消</Button>
                <Button @click="clearUserCard(queryData)" type="primary">确认</Button>
            </div>
        </Modal>
        <!-- 查询日志弹框 -->
        <Modal v-model="showlogs" :closable="false" :mask-closable="false" width="50wv">
            <div>
                <h3>操作日志</h3>
                <br />
                <Table size="small" :columns="logstableData.title" :data="logstableData.list"></Table>
                <div>
                    <Page
                        :total="logstableData.total"
                        :page-size="logstableData.size"
                        size="small"
                        v-model="logstableData.page"
                        @on-change="getShowlogsPage"
                        show-total
                    />
                </div>
            </div>

            <div slot="footer">
                <Button @click="showlogs = false">关闭</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
import { GetPresetValue, ThirdPartyOpenQuery, ThirdPartyOpenOrderRefund } from '../../../request/api';

import { download } from '@/utils/table_download.js';
import dayjs from 'dayjs';
export default {
    name: 'opendata',
    data() {
        return {
            note: '',
            show: false,
            showfrozen: false,
            showbalance: false,
            showlogs: false,
            configThreePlat: {},
            inlineForm: {
                platform: '',
                type: '',
                queryKey: '',
                page: 1,
                all: false,
                time: [],
            },
            inlineRules: {
                platform: { required: true, trigger: 'blur', message: ' ' },
                type: { required: true, trigger: 'blur', message: ' ' },
                queryKey: { required: true, trigger: 'blur', message: ' ' },
            },
            queryData: {},
            tableData: {
                total: 0,
                page: 1,
                size: 1,
                title: [],
                list: [],
            },
            logstableData: {
                total: 0,
                page: 1,
                size: 1,
                title: [],
                list: [],
            },
            logtyps: '',
            options3: {
                // disabledDate(date) {
                //     return (
                //         // (date && date.valueOf() < new Date('2022-01-01').getTime() - 86400000) ||
                //         date &&
                //         date.valueOf() > new Date(this.inlineForm.time[0]).getTime() - 86400000 &&
                //         date &&
                //         date.valueOf() > new Date(dayjs(this.inlineForm.time[0]).add(30, 'day').format('YYYY-MM-DD')).getTime() - 86400000
                //     );
                // },
                disabledDate: (date) => {
                    if (this.inlineForm && this.inlineForm.time[0]) {
                        const startDate = this.inlineForm.time[0];
                        const endDate = new Date(startDate);
                        endDate.setMonth(endDate.getMonth() + 1); // 限制最大可选时间为一个月
                        return date < startDate || date > endDate;
                    }
                    return false; // 如果没有选择开始日期，则不禁用
                },
                // onPick: ({ minDate }) => {
                //     debugger;
                //     if (minDate) <!--{
                //         const maxD--> ate = new Date(minDate);
                //         maxDate.setMonth(maxDate.getMonth() + 1); // 计算一个月后的日期
                //         this.pickerOptions = {
                //             ...this.pickerOptions,
                //             disabledDate: (date) => date < minDate || date > maxDate,
                //         };
                //     }
                // },
            },
        };
    },
    computed: {
        /**
         * 查询数据的配置项
         */
        cpQueryData() {
            if (this.inlineForm.platform) {
                let whichKey = this.inlineForm.platform;
                let data = this.configThreePlat[whichKey];
                return data;
            }
            return [];
        },
        /**
         * 查询条件提示
         */
        cpQueryPlaceHolder() {
            switch (this.inlineForm.type) {
                case '会员信息':
                    return '会员手机号';
                case '订单详情':
                    return '订单号/取票码';
                case '票券详情':
                    return '劵码';
                default:
                    return '';
            }
        },
    },
    mounted() {
        this.handleGetPresetValue();
    },
    methods: {
        showModal() {
            this.note = '';
            this.show = true;
        },
        /**
         * 订单退款
         */
        async orderRefund() {
            if (!this.note) {
                this.$Message.warning('备注不能为空');
                return;
            }
            let passdata = {
                platform: this.inlineForm.platform,
                orderid: this.queryData.orderid,
                note: this.note,
            };
            let res = await ThirdPartyOpenOrderRefund(passdata);
            if (res.errcode != 0) return;
            this.show = false;
            this.search();
        },
        changeType(value) {
            this.queryData = {};
            this.inlineForm.queryKey = '';
        },
        /**
         * 下载表格
         */
        async downloadTable() {
            let passdata = Object.assign({}, this.inlineForm);
            passdata['queryKey'] = this.queryData.userid;
            if (passdata.type.indexOf('报表') != -1) {
                passdata['startTime'] = new Date(passdata.time[0]).Format('yyyy-MM-dd hh:mm');
                passdata['endTime'] = new Date(passdata.time[1]).Format('yyyy-MM-dd hh:mm');
            }
            if (['会员信息', '冻结解冻', '余额清零', '查询用户日志'].includes(this.inlineForm.type)) {
                passdata['type'] = '用户订单';
            }

            passdata['all'] = true;

            let res = await ThirdPartyOpenQuery(passdata);
            if (res.errcode != 0) return;
            let headers = res.data.title;
            let data = res.data.list.map((item) => {
                if (['会员信息', '冻结解冻', '余额清零', '查询用户日志'].includes(this.inlineForm.type)) {
                    return { ...item, orderAbout: item.orderAbout.join('、') };
                }
                if (passdata.type.indexOf('报表') != -1) {
                    return { ...item };
                }
            });
            download({
                worksheet: passdata['type'],
                headers,
                data,
            });
        },
        /**
         * 获取三方平台预设值
         */
        async handleGetPresetValue() {
            let res = await GetPresetValue({ type: '三方平台' });
            if (res.errcode != 0) return;
            this.configThreePlat = res.data;
        },
        async search(page = 1) {
            let passdata = Object.assign({}, this.inlineForm);
            if (passdata.type.indexOf('报表') != -1) {
                passdata['startTime'] = new Date(passdata.time[0]).Format('yyyy-MM-dd hh:mm');
                passdata['endTime'] = new Date(passdata.time[1]).Format('yyyy-MM-dd hh:mm');
                //判断日期选中是否合理
                //2022-01-01之前是不能选择的
                //当前开始时间和结束时间跨度不能超过1一个月
                let disSelectDate = new Date(passdata['startTime']).getTime() < new Date('2022-01-01').getTime() - 86400000;
                if (disSelectDate) {
                    this.$Message.warning('查询开始日期不能少于2022-01-01');
                    return;
                }
                let disSelectDateEnd =
                    new Date(passdata['endTime']).getTime() > new Date(dayjs(this.inlineForm.time[0]).add(31, 'day').format('YYYY-MM-DD')).getTime() - 86400000;
                if (disSelectDateEnd) {
                    this.$Message.warning('选择时间跨度不能超过31天');
                    return;
                }
            } else {
                delete passdata['startTime'];
                delete passdata['endTime'];
            }
            passdata['page'] = page;

            let res = await ThirdPartyOpenQuery(passdata);
            if (res.errcode != 0) return;
            this.queryData = res.data;
            if (passdata.type.indexOf('报表') != -1) {
                this.tableData = res.data;
            }
            if (this.inlineForm.type == '会员信息') {
                this.fetchTableData();
            }
        },
        /**
         * 获取表格数据
         */
        async fetchTableData() {
            let passdata = Object.assign({}, this.inlineForm);
            passdata['queryKey'] = this.queryData.userid;
            passdata['type'] = '用户订单';
            let res = await ThirdPartyOpenQuery(passdata);
            if (res.errcode != 0) return;
            this.tableData = res.data;
        },
        /**
         * 余额清零
         */
        async disableAccount(user) {
            //console.log(user)
            const { status, userid } = user;
            if (!this.note) {
                this.$Message.warning('操作原因不能为空');
                return;
            }
            if (!['正常', '冻结'].includes(status)) {
                return;
            }
            const update = {
                platform: 'frs',
                type: '冻结解冻',
                queryKey: userid,
                page: 1,
                all: false,
                remarks: this.note,
            };
            let res = await ThirdPartyOpenQuery(update);
            if (res.errcode != 0) return;
            this.showfrozen = false;
            this.note = '';
            await this.search(1);
        },
        /**
         * 冻结解冻账号
         */
        async clearUserCard(user) {
            //console.log(user)
            const { membasic, memgiv, userid } = user;
            if (!this.note) {
                this.$Message.warning('操作原因不能为空');
                return;
            }
            if (membasic == 0 && memgiv == 0) {
                this.$Message.warning('当前会员余额为0,无需清零');
                return;
            }
            const update = {
                platform: 'frs',
                type: '余额清零',
                queryKey: userid,
                page: 1,
                all: false,
                remarks: this.note,
            };
            let res = await ThirdPartyOpenQuery(update);
            if (res.errcode != 0) return;
            this.showbalance = false;
            this.note = '';
            await this.search(1);
        },
        getShowlogsPage(page) {
            console.log(page, '===============');
            this.logstableData.page = page;
            this.getShowlogs(this.queryData).then();
        },
        //查看操作日志
        async getShowlogs(user, key = '') {
            const { userid } = user;
            key = key ? key : this.logtyps;
            const isKey = {
                user: '查询用户日志',
            };
            if (!isKey[key]) {
                this.$Message.warning('日志类型错误');
                return;
            }
            this.logtyps = key;
            const update = {
                platform: 'frs',
                type: isKey[key],
                queryKey: userid,
                page: this.logstableData.page,
                all: false,
            };
            this.showlogs = true;
            let res = await ThirdPartyOpenQuery(update);
            if (res.errcode != 0) return;
            this.logstableData = res.data;
        },
    },
};
</script>
